module.exports = __webpack_public_path__ + "static/media/drag-city-win.9e190773.jpg";